<router-outlet></router-outlet>
<ngx-loading [show]="loading"></ngx-loading>
